
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/my-committees",
      function () {
        return require("private-next-pages/account/my-committees/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/my-committees"])
      });
    }
  